export default "__VITE_ASSET__CZ6p8$ln__"